var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C10.6266 1 8.30655 1.70379 6.33316 3.02236C4.35977 4.34094 2.8217 6.21508 1.91345 8.4078C1.0052 10.6005 0.767559 13.0133 1.23058 15.3411C1.6936 17.6689 2.83649 19.807 4.51472 21.4853C6.19295 23.1635 8.33115 24.3064 10.6589 24.7694C12.9867 25.2324 15.3995 24.9948 17.5922 24.0865C19.7849 23.1783 21.6591 21.6402 22.9776 19.6668C24.2962 17.6934 25 15.3734 25 13C24.9955 9.81878 23.7298 6.76915 21.4803 4.51969C19.2308 2.27023 16.1812 1.00451 13 1ZM13 24.4323C10.7389 24.4323 8.5286 23.7618 6.64858 22.5056C4.76855 21.2494 3.30325 19.4639 2.43797 17.3749C1.57269 15.286 1.34629 12.9873 1.78741 10.7697C2.22852 8.55203 3.31734 6.515 4.91617 4.91617C6.515 3.31734 8.55204 2.22852 10.7697 1.7874C12.9873 1.34628 15.286 1.57268 17.3749 2.43796C19.4639 3.30324 21.2494 4.76855 22.5056 6.64857C23.7618 8.5286 24.4323 10.7389 24.4323 13C24.4278 16.0306 23.2218 18.9359 21.0789 21.0789C18.9359 23.2218 16.0306 24.4278 13 24.4323Z",
    fill: "#003FB4",
    stroke: "#003FB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5331 15.9643L16.682 15.1411C15.9391 14.9002 14.9754 15.884 14.9754 15.884C13.0478 15.4222 10.5782 12.9727 10.0964 11.0251C10.0964 11.0251 11.0802 10.0413 10.8392 9.31844L10.016 6.46734C9.93573 6.14608 9.61448 5.96538 9.29323 6.00554L8.89166 6.06577C7.68697 6.26655 6.84369 7.39093 7.02439 8.6157C7.74721 13.7959 12.2046 18.2532 17.3847 18.976C18.5894 19.1367 19.7339 18.3135 19.9347 17.1088L19.9949 16.7072C20.0351 16.3659 19.8343 16.0647 19.5331 15.9643Z",
    fill: "#003FB4",
    stroke: "#003FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.66828986e138863cb996d80b2ae23cf4.svg";
export { ForwardRef as ReactComponent };